/*======================================================================================================================
  * Bluebell: src/app/state/image-deltas/image-deltas.actions.ts
  * Last Edited: 17/07/2025
  * Copyright 2025 Bramble CFD LTD
  * The contents of this file are NOT for redistribution
  * See AUTHORS for list of developers on this project
 =====================================================================================================================*/
import { createAction, props } from '@ngrx/store';
import { ImageDelta, ImageDeltaFilters, ImageDeltaFilterState } from '@state/image-deltas/image-deltas.interfaces';


const name = (action: string) => `[Image Delta] ${action}`;

export const listImageDeltas = createAction(name('List'), props<{ caseIds: string[] }>());
export const listImageDeltasSuccess = createAction(name('List Success'), props<{ data: ImageDelta[], filters: ImageDeltaFilters }>());
export const listImageDeltasFailure = createAction(name('List Failure'));

export const listImageDeltaAvailableVariables = createAction(name('List Available Variables'), props<{ caseIds: string[] }>());
export const listImageDeltaAvailableVariablesSuccess = createAction(
  name('List Available Variables Success'),
  props<{ availableVariables: string[] }>()
);
export const listImageDeltaAvailableVariablesFailure = createAction(name('List Available Variables Failure'));
export const clearImageDeltaAvailableVariables = createAction(name('Clear Available Variables'));


export const addImageDeltaFilter = createAction(name('Add Filter'), props<{filter: keyof ImageDeltaFilterState, value: string }>());
export const removeImageDeltaFilter = createAction(name('Remove Filter'), props<{filter: keyof ImageDeltaFilterState, value: string }>());
export const resetImageDeltaFilterState = createAction(name('Reset Filters'));
export const patchImageDeltaFilterState = createAction(
  name('Patch Image Delta Filter State'),
  props<{ partialFilterState: Partial<ImageDeltaFilterState> }>()
);
export const setImageDeltaFilterState = createAction(
  name('Set Image Delta Filter State'),
  props<{ filterState: ImageDeltaFilterState }>()
);
